import React, { useState } from "react";
import { Modal, Button, Typography } from "antd";
import infoIconSmallTrukker from '../../../assets/images/info-icon-small.svg';
import infoIconSmallAdeed from '../../../assets/adeed/images/info-icon-small.svg';
import { useTranslation } from "react-i18next";
import { isAdeed } from "../../../constants/brand";

// ADEED Freight shows its blue copies of these images (src/assets/adeed).
const infoIconSmall = isAdeed ? infoIconSmallAdeed : infoIconSmallTrukker;

const { Paragraph } = Typography;

const InvoiceInstructions = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const instructions = [
    t("INV_UPL_INSTRUCTIONS_ONE"),
    t("INV_UPL_INSTRUCTIONS_TWO"),
    t("INV_UPL_INSTRUCTIONS_THREE"),
    t("INV_UPL_INSTRUCTIONS_FOUR"),
    t("INV_UPL_INSTRUCTIONS_FIVE"),
    t("INV_UPL_INSTRUCTIONS_SIX"),
    t("INV_UPL_INSTRUCTIONS_SEVEN"),
  ];

  return (
    <>
      <Button type="link" style={{color:"var(--attention, #F99E00)",textDecoration:"underline",padding:"0px"}} onClick={() => setOpen(true)}>
        {t("INV_UPL_INSTRUCTIONS_BTN")}<img src={infoIconSmall} alt="infoIcon" />
      </Button>

      <Modal
        title={t("INV_UPL_INSTRUCTIONS_BTN")}
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key="close" onClick={() => setOpen(false)}>
            {t("INV_UPL_INSTRUCTIONS_CLOSE_BTN")}
          </Button>,
        ]}
      >
        <ol style={{ paddingLeft: "20px" }}>
          {instructions.map((item, index) => (
            <li key={index} style={{ marginBottom: "12px" }}>
              <Paragraph style={{ marginBottom: 0 }}>
                {item}
              </Paragraph>
            </li>
          ))}
        </ol>
      </Modal>
    </>
  );
};

export default InvoiceInstructions;